// TOP LEVEL IMPORTS
import React from 'react';
// ANTD
import Button from 'antd/lib/button';
import Spin from 'antd/lib/spin';
import Row from 'antd/lib/row';
import Icon from 'antd/lib/icon';
import message from 'antd/lib/message';
import Modal from 'antd/lib/modal';
// COMPONENTS
import PageContainer from 'components/common/PageContainer';
import CreateStudioForm from 'components/forms/CreateStudioForm';


// CONSTANTS & DESTRUCTURING
// ===================================

// STYLES
// ===================================


class CreateStudioModal extends React.Component {
  state = { visible: false };

  render() {
    return (
      <div style={{ marignTop: 10, minHeight: 400 }}>
        <Button size="large" onClick={() => this.setState({ visible: true })} type="primary">
          CREATE STUDIO
        </Button>
        <Modal
          title="Create a Studio"
          visible={this.state.visible}
          onOk={() => console.log('onOk')}
          onCancel={() => this.setState({ visible: false })}
          footer={null}
        >
          <CreateStudioForm {...this.props} />
        </Modal>
      </div>
    );
  }
}

const Loading = () => {
  return (
    <Row
      type="flex"
      align="middle"
      justify="center"
      style={{ background: '#fff', minHeight: 450, maxWidth: '100%', width: 700, margin: 'auto' }}
    >
      <Spin />
    </Row>
  );
};

class NoStudioModal extends React.Component {
  onCreateStudio = () => {
    message.success('create studio modal will open');
  };

  renderTop = () => {
    return (
      <div style={{ marginBottom: 20 }}>
        <Icon type="folder-open" style={{ fontSize: 100, color: '#ddd' }} />
        <div>
          <h2>CAN'T FIND YOUR STUDIO...</h2>
          <h3>Get started by creating your studio profile.</h3>
        </div>
      </div>
    );
  };

  renderBottom = () => {
    return <CreateStudioModal {...this.props} />;
  };

  render() {
    return (
      <PageContainer>
        <div style={{ textAlign: 'center', marginTop: 60 }}>
          {this.renderTop()}
          {this.renderBottom()}
        </div>
      </PageContainer>
    );
  }
}

export default NoStudioModal;



// WEBPACK FOOTER //
// ./src/routes/app-studio/NoStudioModal/index.js